import taskApi from '@/api/task';
import { Button, message, Modal } from 'antd';
import { useState } from 'react';

const CancelTaskModal = ({ taskId, onCancel }: { taskId: string; onCancel: (cancel: boolean) => void }) => {
    const [cancelLoading, setLoading] = useState(false);
    const canceltask = async () => {
        setLoading(true);
        try {
            const res = await taskApi.cancelTask(taskId);
            onCancel(true);
        } catch (error: any) {
            message.error(error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
    return (
        <Modal
            open={taskId ? true : false}
            centered
            maskClosable={false}
            closeIcon={<img src={require('@/assets/images/Icons_Cross.png')} alt="" onClick={() => onCancel(false)} />}
        >
            <div className="modal-title" style={{ marginTop: 37 }}>
                Are you sure you want to cancel this task?
            </div>
            <div className="modal-tip ">
                Please ensure that canceling this task is appropriate. Once canceled, this action cannot be undone.
            </div>
            <div className="flex-center" style={{ marginTop: 30, columnGap: 20 }}>
                <Button
                    className="submit-btn"
                    onClick={() => onCancel(false)}
                    style={{ color: '#979797', borderColor: '#979797' }}
                >
                    Not yet
                </Button>
                <Button className="submit-btn" type="primary" danger loading={cancelLoading} onClick={canceltask}>
                    Cancel Task
                </Button>
            </div>
        </Modal>
    );
};
export default CancelTaskModal;
